import { render } from "./CharlaIcons.vue?vue&type=template&id=5d10e9a4&scoped=true"
import script from "./CharlaIcons.vue?vue&type=script&lang=js"
export * from "./CharlaIcons.vue?vue&type=script&lang=js"

import "./CharlaIcons.vue?vue&type=style&index=0&id=5d10e9a4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d10e9a4"]])

export default __exports__